import React, { useSyncExternalStore } from 'react';
import { Modal } from 'react-bootstrap';
import CasinoResultContent from '@userfe/components/casino/common/tableLayout/CasinoResultContent.jsx';
import { baseCasinoType } from '../../utils/casinoGame';
import { getLastCasinoDetail, subscribeLastCasinoDetail } from '../../utils/lastCasinoDetail';
import '../../styles/deposit-modal.css';
import '../StatementResultModal/userResult.css';
import styles from './ResultModalLayout.module.css';
import RoundBets from '../RoundBets';
import './CasinoResultModal.css';
import './originalResultLook.css';

// Game types jinka result layout user site (@userfe CasinoResultContent) me hai —
// wahi original admin wala design hai (cards, trophy, winner/total box).
const USER_RESULT_TYPES = new Set([
  '3cardj', 'aaa', 'aaa2', 'ab20', 'ab3', 'ab4', 'abj', 'baccarat', 'baccarat2', 'ballbyball',
  'btable', 'btable2', 'card32', 'card32eu', 'cmatch20', 'cmeter', 'cmeter1', 'cricketv3',
  'dolidana', 'dt20', 'dt202', 'dt6', 'dtl20', 'dum10', 'goal', 'joker1', 'joker120', 'joker20',
  'lottcard', 'lucky15', 'lucky5', 'lucky7', 'lucky7eu', 'lucky7eu2', 'mogambo', 'notenum',
  'ourroullete', 'patti2', 'poison', 'poison20', 'poker', 'poker20', 'poker6', 'queen', 'race17',
  'race2', 'race20', 'roulette11', 'roulette12', 'roulette13', 'sicbo', 'sicbo2', 'superover',
  'superover2', 'superover3', 'teen', 'teen1', 'teen120', 'teen20', 'teen20b', 'teen20c', 'teen3',
  'teen32', 'teen33', 'teen41', 'teen42', 'teen6', 'teen62', 'teen8', 'teen9', 'teenmuf',
  'teensin', 'teenunique', 'threecardj', 'trap', 'trio', 'war', 'worli', 'worli2',
]);

// vteen20 → teen20, pteen20 → teen20 (virtual / premium feed ka result shape same hai)
function userResultType(type) {
  const t = baseCasinoType(type);
  if (USER_RESULT_TYPES.has(t)) return t;
  if (t.startsWith('p') && USER_RESULT_TYPES.has(t.slice(1))) return t.slice(1);
  return null;
}

const hasT1 = (res) => !!(res?.data?.data?.t1 || res?.data?.t1);

/**
 * Common casino result modal (saare resultui/* widgets yahi use karte hain).
 *
 * Jo round abhi getDetailResults() se aaya (utils/lastCasinoDetail.js), agar us game
 * ka layout user site me hai to body wahi user-site renderer banata hai — original
 * admin jaisa (cards + trophy + Winner/Total box, Match Time dd/mm/yyyy HH:mm:ss).
 * Warna purana admin body (children) dikhta hai.
 *
 * Modal tab tak nahi khulta jab tak `loading` true hai — pehle "Loading..." ke saath
 * khul kar phir content badalta tha, jo flicker jaisa dikhta tha.
 */
const ResultModalLayout = ({
  show,
  onHide,
  title,
  roundId,
  matchTime,
  children,
  loading = false,
}) => {
  const last = useSyncExternalStore(subscribeLastCasinoDetail, getLastCasinoDetail);
  const userType = last && hasT1(last.response) ? userResultType(last.type) : null;

  // Titles kahin "Mogambo" aur kahin "Mogambo Result" aate hain — "Result Result" na bane
  const cleanTitle = String(title ?? '').replace(/\s*result\s*$/i, '');

  return (
    <Modal
      show={show && !loading}
      onHide={onHide}
      dialogClassName={`modal-dialog-scrollable casino-result-modal-dialog-80 ${styles.modalDialogCustom}`}
    >
      <Modal.Header>
        <Modal.Title>
          {cleanTitle} Result
        </Modal.Title>
        <button
          type="button"
          className="close text-white"
          onClick={onHide}
          aria-label="Close"
        >
          ×
        </button>
      </Modal.Header>
      <Modal.Body className={styles.modalBodyScroll}>
        {userType ? (
          // CSS variables (.stmt-user-result-dialog) sirf body par — header original
          // admin jaisa safed + gol neela × hi rahe (dialog par lagane se header neela ho jaata tha)
          <div className={`stmt-user-result-dialog admin-original-result game-${userType}`}>
            <div className="stmt-user-result">
              <CasinoResultContent gameType={userType} detailData={last.response} />
            </div>
          </div>
        ) : (
          <div className="casino-result-modal">
            <div className="casino-result-round">
              <div>Round-ID: {roundId || "N/A"}</div>
              <div>Match Time: <span>{matchTime || "N/A"}</span></div>
            </div>
            <div className="row row5">
              {children}
            </div>
          </div>
        )}
        {/* the round's downline bets (hidden when there are none) */}
        <RoundBets show={show && !loading} roundId={roundId} />
      </Modal.Body>
    </Modal>
  );
};

export default ResultModalLayout;
